import { filtersEpics } from './filters/filters.epics';

export const roiEpics = [...filtersEpics];
